import React from "react";
import { createPortal } from "react-dom";

/**
 * Tiny bouncing chevron fixed to the bottom of the viewport. Tapping scrolls
 * to the contact / quote section. Mobile only - parent gates visibility.
 */
const ScrollNudge = ({
  visible,
  targetId = "lp2-contact",
  ariaLabel = "Scroll to email and get your quotation",
}) => {
  if (!visible || typeof document === "undefined") return null;

  const scrollToTarget = () => {
    document
      .getElementById(targetId)
      ?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return createPortal(
    <div className="lp2-portal-root">
      <button
        type="button"
        className="lp2-scroll-nudge"
        aria-label={ariaLabel}
        onClick={scrollToTarget}
      >
        <i className="mdi mdi-chevron-double-down" aria-hidden="true" />
      </button>
    </div>,
    document.body,
  );
};

export default ScrollNudge;
